import { setupHeader } from './components/header';
import { setupParallaxImages } from './components/parallax-image';
import { setupProductInspiration } from './components/product-inspiraton';
import { setupCanvas } from './components/canvas';
import { setupUsps } from './components/usps';
import { onReady } from './utils/onReady';
import { isTouch, initVhUnitOverwrite } from './utils/helpers';
import { setupNavigation } from './components/navigation';
import { setupCalculator } from './components/calculator';
import { setupInspirationFilter } from './components/inspiraton-filter';
import { setupAccordions } from './components/accordion';
import { setupNewsFilter } from './components/news-filter';
import { setupGalleries } from './components/gallery';
import { setupFilters } from './components/filter';
import { setupToggleContent } from './components/toggle-content';
import { setupDeliveryDates } from './components/delivery-dates';
import { setupMaps } from './components/map';
import { setupTabs } from './components/tabs';
import { setupIGO } from './components/image-gallery-overlay';
import { setupProductImages } from './components/product-images';
import { setupProductFloatingBar } from './components/product-floating-bar';
import { setupSwipers } from './components/swiper';
import { setupIntersect } from './components/intersect';
import { setupImageLoad } from './components/image-load';
import { setupProductModal } from './components/product-modal';
import { setupCounters } from './components/counter';
import { setupFormSubmit } from './components/forms';
import { setupProductOverviewModal } from './components/product-overview';
import { setupMoveProductData } from './utils/moveContent';
import { setupSearchSelects } from './components/search-select';
import { setupDuoRangeSliders } from './components/duo-range-slider';
import { setupCheckoutHelpers } from './components/checkout-helpers';
import { setupSearch } from './components/search';
import { setupAltCartCount } from './components/cart-counter';
import { addPasswordInputValidation } from './components/password-input-validation';

function init() {
    document.body.classList.remove('standby');
    document.body.setAttribute('data-is-touch', isTouch);

    onReady(() => {

        setupHeader();
        initVhUnitOverwrite();
        setupProductInspiration();
        setupCanvas();
        setupUsps();
        setupNavigation();
        setupCalculator();
        setupInspirationFilter();
        setupAccordions();
        setupNewsFilter();
        setupFilters();
        setupGalleries();
        setupToggleContent();
        setupDeliveryDates();
        setupMaps();

        setTimeout(() => {
            setupSwipers();
        }, 5000);

        setupCounters();
        setupMoveProductData();
        setupTabs();
        setupIGO();
        setupProductImages();
        setupProductFloatingBar();
        setupProductModal();
        setupIntersect();
        setupImageLoad();
        setupProductOverviewModal();
        setupFormSubmit();
        setupSearchSelects();
        setupDuoRangeSliders();
        setupCheckoutHelpers();
        setupSearch();
        setupAltCartCount();
        addPasswordInputValidation();
});

    window.addEventListener('load', () => {
        setupParallaxImages();
    });
}

init();